export const sortItems = (
  items,
  sortBy,
  descending = false,
  boolean = false
) => {
  if (descending) {
    return items.sort((a, b) => {
      const valueA = !boolean && a[sortBy] ? a[sortBy].toLowerCase() : a[sortBy];
      const valueB = !boolean && b[sortBy] ? b[sortBy].toLowerCase() : b[sortBy];

      if (valueA < valueB) {
        return 1;
      }
      if (valueA > valueB) {
        return -1;
      }
      return 0;
    });
  } else {
    return items.sort((a, b) => {
      const valueA = !boolean && a[sortBy] ? a[sortBy].toLowerCase() : a[sortBy];
      const valueB = !boolean && b[sortBy] ? b[sortBy].toLowerCase() : b[sortBy];

      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    });
  }
};


export const getColorClass = (communityType: string) => {
  switch (communityType) {
    case 'Open':
      return 'community-open';
    case 'Private':
      return 'community-closed';
    case 'Hidden':
      return 'community-hidden';
    default:
      return 'govTeams-blue';
  }
};